import { generateId } from '@freelancer/datastore/testing/helpers';
import type { SupportIssueCategory } from './support-issue-categories.model';

export interface GenerateSupportIssueCategoryOptions {
  readonly id?: string;
  readonly accountType?: 'freelancer' | 'employer';
  readonly name?: string;
  readonly parent?: string;
  readonly subcategories?: readonly SupportIssueCategory[];
}

export function generateSupportIssueCategoryObject({
  id = generateId().toString(),
  accountType = 'freelancer',
  name,
  parent,
  subcategories,
}: GenerateSupportIssueCategoryOptions): SupportIssueCategory {
  return {
    id,
    accountType,
    name: name ?? `Issue Category ${id}`,
    active: true,
    priority: 1,
    parent,
    supportIssueCategoryVersionId: generateId().toString(),
    forFreelancer: true,
    forEmployer: true,
    supportIssueCategoryDepartmentId: generateId().toString(),
    departmentName: 'Test Department',
    departmentParentName: 'Test Parent Department',
    subcategories,
  };
}

export function generateSupportIssueCategoryObjects(
  categories: readonly GenerateSupportIssueCategoryOptions[],
): readonly SupportIssueCategory[] {
  return categories.map(category =>
    generateSupportIssueCategoryObject(category),
  );
}
